import addQueryParam from '@/utils/addQueryParam'

const baseUrl = `${import.meta.env.VITE_BASE_URL}`.replace(/\/$/, '')
const searchBaseUrl = `${import.meta.env.VITE_CLIENT_API_URL}`.replace(/\/$/, '')
// Helper function to build video URLs
function buildFeedUrl(feedId, query, user_id) {
  let url;

  if (query && query.trim() !== '') {
    url = `${searchBaseUrl}/search-data/${feedId}?name=${encodeURIComponent(query)}`
  } else {
    url = `${baseUrl}/${feedId}/videodeck`
  }

  if (user_id) {
    url = addQueryParam(url, 'user_id', user_id);
  }

  return url;
}

export { buildFeedUrl }